import React from 'react';
import Alert from 'react-s-alert';
import Row from '../../../shared/components/Row';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../../shared/components/CardBody';
import Paginator from '../../../shared/components/Paginator';
import { WorkerSearchRequest } from './worker-search/WorkerSearchRequest';
import { WorkerSearchTask } from './worker-search/WorkerSearchTask';
import { WorkerStateListTask } from './worker-state-list/WorkerStateListTask';
import { PsWorker } from '../PsWorker';
import { WorkerListTable } from './WorkerListTable';
import { CurrentUser } from '../../../shared/model/CurrentUser';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import WorkerState from '../../../shared/model/WorkerState';
import { WorkersExportRequest } from './workers-export/WorkersExportRequest';
import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';
import cookie from 'react-cookies';
import { AUTH_TOKEN } from '../../../shared/utils/CookiesManager';

class WorkerList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            search: props.initialCardState.search,
            filter: props.initialCardState.filter,
            loading: false,
            filters: [],
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
        };
    }

    componentDidMount() {
        this.listWorkerStates();
        this.listWorkers();
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const { search, filter } = this.state;

        if ( prevState.filter !== filter ) {
            saveCardState({ filter });
        }

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }
    }

    renderRightOptions() {
        const {search} = this.state;

        const moreOptions = [
            {
                title: I18nUtils.tr('TR_EXPORTAR_CSV'),
                onClick: this.exportCsv,
            },
        ];

        return (
            <HeaderSearchRefreshFilterOptions
                enableFilter={true}
                filterOptions={this.filterOptions()}
                searchText={search}
                onRefresh={this.listWorkers}
                onSearch={this.search}
                moreOptions={moreOptions}
            />
        )
    }

    render() {
        const {
            data,
            error,
            loading,
            pagination,
        } = this.state;

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODOS_LOS_TRABAJADORES').toUpperCase()}
                        subtitle={this.subtitle()}
                        rightOptions={this.renderRightOptions()}
                    />
                    <CardBody>
                        <WorkerListTable
                            data={data}
                            error={error}
                            loading={loading}
                        />
                        <Paginator
                            data={pagination}
                            onPage={this.selectPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

    exportCsv = () => {
        const { companyId } = this.props;
        const { page, search, filter } = this.state;
        const request = new WorkersExportRequest(companyId);

        request.setPage(page);
        request.setTerm(search);
        request.setWorkerState(filter);

        const genericRequest = new GenericRequest(METHOD_POST, ApiEndpoints.WORKERS_EXPORT);
        let headers = genericRequest.headers;
        const authToken = cookie.load(AUTH_TOKEN);
        if (authToken) {
            headers.Authorization = 'Bearer ' + cookie.load(AUTH_TOKEN);
        }
        const requestInit = {
            method: genericRequest.method,
            headers: headers,
            mode: 'cors',
            body: JSON.stringify(request.body()),
        };
        this.setState({ loading: true });
        fetch(genericRequest.url, requestInit)
            .then(response => {
                this.setState({ loading: false });
                response.blob().then(function (myBlob) {
                    const url = URL.createObjectURL(myBlob);
                    window.open(url, '_blank');
                });
            })
            .catch(error => {
                this.setState({loading: false});
                Alert.error(error || I18nUtils.tr('TR_ERROR_AL_EXPORTAR_EL_CSV'));
            });
    }

    search = (search) => {
        this.setState({ search, page: 1 }, this.listWorkers);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listWorkers);
    };

    listWorkers = () => {
        const { currentUser, companyId } = this.props;
        const { page, search, filter } = this.state;
        const request = new WorkerSearchRequest(companyId);

        request.setPage(page);
        request.setTerm(search);
        request.setWorkerState(filter);

        new WorkerSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const data = PsWorker.fromAPIWorkers(res.data, currentUser);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    listWorkerStates = () => {
        new WorkerStateListTask()
            .onSuccess((res) => {
                const filters = this.parseToFilterOptions(res.data);
                this.setState({ filters });
            })
            .onFail((error) => Alert.error(error))
            .execute();
    };

    parseToFilterOptions = (states) => {
        const options = [{
            id: -1,
            title: I18nUtils.tr('TR_TODOS'),
            onClick: () => this.setState({ filter: -1, page: 1 }, this.listWorkers),
        }];

        states.forEach((state) => {
            options.push({
                id: state.id,
                title: state.name,
                onClick: () => this.setState({ filter: state.id, page: 1 }, this.listWorkers),
            });
        });

        return options;
    };

    filterOptions = () => {
        return this.state.filters.map((filter) => ( {
            ...filter,
            active: filter.id === this.state.filter,
        } ));
    };

    subtitle = () => {
        const currentFilter = this.state.filters.find((f) => f.id === this.state.filter);
        return currentFilter ? currentFilter.title : '';
    };
}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

export const WorkerListCard = connect(mapStateToProps)(WorkerList);

WorkerListCard.propTypes = {
    companyId: PropTypes.number,
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object.isRequired,
};

WorkerListCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        search: '',
        filter: WorkerState.ALL,
    },
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/list/WorkerListCard.jsx